export default __webpack_public_path__ + "static/media/TheTruckingForme_banner.bd34492d.png";